"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
export interface TokenPriceHistoryPoint {
  timestamp: number;
  date: string;
  open: number;
  high: number;
  low: number;
  close: number;
  priceUsd: number;
  volumeUsd: number;
}
export interface TokenPriceHistoryResponse {
  chainId: number;
  network: string;
  requestedTokenAddress: string;
  tokenAddress: string;
  poolAddress: string | null;
  poolName: string | null;
  points: TokenPriceHistoryPoint[];
  source: "geckoterminal";
  resolution: "1d";
}
async function fetchTokenPriceHistory(tokenAddress: string, chainId: number): Promise<TokenPriceHistoryResponse | null> {
  const params = new URLSearchParams({
    tokenAddress,
    chainId: String(chainId)
  });
  const response = await fetch(`/api/token-price-history?${params.toString()}`);
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    throw new Error(`Failed to fetch token price history: ${response.statusText}`);
  }
  try {
    return (await response.json()) as TokenPriceHistoryResponse;
  } catch {
    throw new Error("Invalid response format from token price history API");
  }
}
interface UseTokenPriceHistoryOptions {
  tokenAddress?: string;
  chainId?: number;
  enabled?: boolean;
}
export function useTokenPriceHistory(t0) {
  const $ = _c(8);
  const {
    tokenAddress,
    chainId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== chainId || $[1] !== tokenAddress) {
    t2 = ["token-price-history", chainId, tokenAddress];
    t3 = () => {
      if (!tokenAddress || !chainId) {
        throw new Error("Missing required parameters");
      }
      return fetchTokenPriceHistory(tokenAddress, chainId);
    };
    $[0] = chainId;
    $[1] = tokenAddress;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const t4 = enabled && Boolean(tokenAddress) && Boolean(chainId);
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: 300000,
      gcTime: 900000,
      retry: 1
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return useQuery(t5);
}